<template>
    <b-modal ref="customers-modal" hide-footer hide-header static>
        <div class="d-block text-center">
           <div class="col-2">< Back</div>
           <div class="col-8"><h2 class="font-weight-bold ">Select Customer</h2></div>
           <div class="col-2">+</div>
         <ul>
             <li>
                 <div class="d-inline">
                     <h5 class="font-weight-bold float-left">Molel Levy</h5>
                     <p class="text-gray float-right">Amani Plaza, Kinoo</p>
                 </div>

                 <p class="text-gray">Amani Plaza, Kinoo</p>
             </li>
         </ul>
            <!--<i v-on:click="qtyDecrease()" class="bi bi-dash-square-fill"></i>  <i v-on:click="qtyIncrease()"class="bi bi-file-plus-fill"></i>-->
        </div>

    </b-modal>
</template>

<script>
    export default {
        name: "customers"
    }
</script>

<style scoped>

</style>